import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import { Languages, Loader2 } from "lucide-react";
import { endpoints } from "@/api";
import { toast } from "sonner";
import { useI18n } from "@/i18n";

/**
 * Small inline button that translates `sourceText` to `target` ('ar' or 'en')
 * using the admin translate endpoint (Gemini), then calls onTranslated(result).
 */
export default function TranslateButton({ sourceText, target, onTranslated, testid }) {
  const { isRTL } = useI18n();
  const [busy, setBusy] = useState(false);
  const label = target === "ar"
    ? (isRTL ? "ترجم → عربي" : "Translate → AR")
    : (isRTL ? "ترجم → إنجليزي" : "Translate → EN");

  const go = async () => {
    const src = (sourceText || "").trim();
    if (!src) {
      toast.error(isRTL ? "أدخل النص الأصلي أولاً" : "Enter source text first");
      return;
    }
    setBusy(true);
    try {
      const res = await endpoints.adminTranslate(src, target);
      if (res?.translated) {
        onTranslated(res.translated);
        toast.success(isRTL ? "تمت الترجمة" : "Translated");
      } else {
        toast.error(isRTL ? "تعذّرت الترجمة" : "Translation failed");
      }
    } catch (e) {
      toast.error(e?.response?.data?.detail || (isRTL ? "تعذّرت الترجمة" : "Translation failed"));
    } finally {
      setBusy(false);
    }
  };

  return (
    <Button
      type="button"
      size="sm"
      variant="outline"
      onClick={go}
      disabled={busy}
      className="h-7 px-2 text-[10px] border-[#C86240]/30 text-[#C86240] hover:bg-[#C86240]/5"
      data-testid={testid}
    >
      {busy ? <Loader2 className="w-3 h-3 me-1 animate-spin" /> : <Languages className="w-3 h-3 me-1" />}
      {label}
    </Button>
  );
}
